import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaymentService } from '../payment/services/payment.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { EbitService } from '../shared/services/ebit.service';
import { SubscriptionModel } from '../shared/models/payment/order/subscription.model';
import { ClientModel } from '../shared/models/client.model';
import { CommonHttpService } from '../shared/services/http.service';
import { OauthService } from '../shared/services/oauth.service';
import { OrderModel } from '../shared/models/payment/order/order.model';
import { OfferModel } from '../shared/models/payment/offer.model';
import { DataLayerService } from '../shared/data-layer/data-layer.service';

@Component({
    selector: 'completed',
    templateUrl: './completed.component.html',
    styleUrls: ['./completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedComponent implements OnInit {
    public client: ClientModel;
    public offers: Array<OfferModel|OrderModel|SubscriptionModel>;
    public loading = false;
    public hasEbitStore = false;
    public ebitStoreId = '';

    public storeConfigurations = [];
    public hasGoogleConversionId = false;
    public googleConversionId = null;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected router: Router,
        protected paymentService: PaymentService,
        protected titleService: Title,
        protected translate: TranslateService,
        protected ebitService: EbitService,
        protected http: CommonHttpService,
        protected oauth: OauthService,
        protected dataLayer: DataLayerService
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe(data => {
            this.storeConfigurations = data;
            if (
                data['google-conversion-id'] !== undefined
                && data['google-conversion-id'] !== null
            ) {
                this.hasGoogleConversionId = true;
                this.googleConversionId = data['google-conversion-id'];
            }
        });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });

        this.translate
            .get('COMPLETED.TITLE')
            .subscribe((title: string) => this.titleService.setTitle(title+ ' | ' + this.activatedRoute.snapshot.data.storeConfigurations.store_name));

        this.ebitService.configurationLoaded$.subscribe(() => {
            this.hasEbitStore = this.ebitService.getEbitStoreId() !== null;
            this.ebitStoreId = `${+this.ebitService.getEbitStoreId()}`;
        });

        this.oauth.loadingAuthenticatedUser$.subscribe(() => {
            this.loading = true;
        });
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.loading = false;
            this.client = client;
        });
        this.oauth.failedAuthenticatedUser$.subscribe(() => {
            return this.router.navigate(
                ['/checkout/cart'],
                {
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                }
            );
        });

        if (!this.paymentService.hasOffers()) {
            this.loading = false;
            this.router.navigate(
                ['/checkout/cart'],
                {
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                }
            );
        } else {
            this.loading = false;
            this.offers = this.paymentService.getOffers();
            this.dataLayer.finalized(this.offers);
        }
    }

    ngOnInit() {
        window.scrollTo(0, 0);
    }

    /**
     * Check if offer has OrderModel attributes.
     **/
    public isOrder(offer) {
        return offer.items !== undefined;
    }
    /**
     * Check if offer has SubscriptionModel attributes.
     **/
    public isSubscription(offer) {
        return offer.plan !== undefined;
    }
    /**
     * Check if offer's payment method is bank slip.
     **/
    public isBankSlip(offer: OfferModel) {
        return offer.payment_method.type === 'bank slip';
    }
    /**
     * Check if offer's payment method is pix.
     **/
    public isPix(offer: OfferModel) {
        return offer.payment_method.type === 'pix';
    }
    /**
     * Checking if offer is order and a huge content by items length.
     **/
    public isHugeOrder(offer) {
        return this.isOrder(offer)
            && offer.items.length > 10;
    }
    /**
     * Get name from payment method attribute from offer.
     **/
    public getPaymentMethod(offer: OfferModel): string {
        return offer.payment_method.name;
    }
    /**
     * Get bank slip url if payment method is bank slip or return an empty
     * string.
     **/
    public getBankSlipUrl(offer: OfferModel): string {
        if (this.isBankSlip(offer)) {
            return offer.bank_slip_url;
        }
        return '';
    }
    /**
     * Get payment code Qr if payment method is pix or bank slip or return an empty
     * string.
     **/
    public getPaymentCodeQr(offer: OfferModel): string {
        if (this.isPix(offer)){
            return encodeURIComponent(offer.payment_code);
        }

        if (this.isBankSlip(offer)) {
            return offer.payment_code;
        }
        return '';
    }

    /**
     * Get payment code if payment method is pix or bank slip or return an empty
     * string.
     **/
    public getPaymentCode(offer: OfferModel): string {
        if (this.isPix(offer)){
            return offer.payment_code;
        }

        if (this.isBankSlip(offer)) {
            return offer.payment_code;
        }
        return '';
    }

    /**
     * Return offer's payment card if not is bank slip.
     **/
    public getPaymentCard(offer: OfferModel) {
        if (!this.isBankSlip(offer) && !this.isPix(offer)) {
            return offer.payment_card;
        }
        return null;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/completed/completed.component.ts